import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class PortalAuthContextService {
  private context: any = null;
  private portalLoggedIn = false;

  setContext(ctx: any) {
    this.context = ctx;
  }

  getContext() {
    return this.context;
  }

  setPortalLoginSuccess() {
    this.portalLoggedIn = true;
    sessionStorage.setItem('portalLoggedIn', 'true');
  }

  isPortalLoggedIn(): boolean {
    return this.portalLoggedIn || sessionStorage.getItem('portalLoggedIn') === 'true';
  }

  clear() {
    this.context = null;
    this.portalLoggedIn = false;
    sessionStorage.removeItem('portalLoggedIn');
  }
}
